import { Box, SxProps, Theme } from "@mui/material";
import { ReactElement, useEffect, useState } from "react";
// import { DragDropContext, DraggableProvided, Droppable, OnDragEndResponder } from "react-beautiful-dnd"
import { DragDropContext, DraggableProvided, Droppable, OnDragEndResponder } from '@hello-pangea/dnd'
import { DragItem } from "./item";

type List = Array<{ id: string; label?: string }>
type Item = { id: string; label?: string }
type Props = {
    list: List
    listStyles?: SxProps<Theme>
    children?:JSX.Element
    model?: (payload: { item: Item; provided: DraggableProvided; index: number }) => ReactElement
    newOrder: (list: List) => void
    click?: (payload:{id: string; index: number; item: Item}) => void
}
const DragAndDrop = ({ list, listStyles, children, click, model, newOrder }: Props) => {
    const [item, setItems] = useState<List>(list)
    const reorder = (list: List, startIndex: number, endIndex: number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        if(newOrder) {
            newOrder(result)
        }
        return result;
    };

    const onDragEnd: OnDragEndResponder = (result) => {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            item,
            result.source.index,
            result.destination.index
        );

        setItems(items)
    }

    const getItemStyle = (_: boolean, draggableStyle?: any) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 8 * 2,
        margin: `0 0 ${8}px 0`,
        height: 'fit-content',

        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = () => ({
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        height: 'calc(100%)',
        width: '100%',
        ...listStyles ?? {}
    });

    useEffect(() => {
        setItems(list)
    }, [list])
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided,) => (
                    <Box
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        sx={getListStyle()}
                    >
                        {
                            item?.map((itemOfList, index) => (
                                <DragItem
                                    getItemStyle={getItemStyle}
                                    index={index}
                                    itemOfList={itemOfList}
                                    model={model}
                                    click={click}
                                    children={children}
                                />
                            ))
                        }
                        {provided.placeholder}
                    </Box>
                )}
            </Droppable>
        </DragDropContext>
    )
}
export type { Item }
export { DragAndDrop }
